// Display metadata for each domiciliary-schedule draft-change type, shared by
// the publish-review modal so labels / colours stay consistent. Mirrors the
// duty-roster changeMeta.
export const CHANGE_TYPE_META = {
  assign:         { group: 'Carer assignments',   cls: 'bg-blue-100 text-blue-700 dark:bg-blue-900/20 dark:text-blue-400',       dot: 'bg-blue-500',    icon: '↗' },
  timeAway:       { group: 'Time away',           cls: 'bg-sky-100 text-sky-700',         dot: 'bg-sky-500',     icon: '!' },
  removeTimeAway: { group: 'Removed time away',   cls: 'bg-amber-100 text-amber-700 dark:bg-amber-900/10 dark:text-amber-400',     dot: 'bg-amber-500',   icon: '−' },
  availability:   { group: 'Extra availability',  cls: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/10 dark:text-emerald-400', dot: 'bg-emerald-500', icon: '＋' },
  stopVisit:      { group: 'Stopped packages',    cls: 'bg-rose-100 text-rose-700',       dot: 'bg-rose-500',    icon: '⊘' },
  review:         { group: 'Recorded hours',      cls: 'bg-indigo-100 text-indigo-700',   dot: 'bg-indigo-500',  icon: '◷' },
};

export const changeTypeMeta = (type) =>
  CHANGE_TYPE_META[type] || { group: type, cls: 'bg-slate-100 text-slate-700', dot: 'bg-slate-500', icon: '✎' };

// Group a flat change queue by type, preserving first-seen order, each with its
// display metadata — used by the publish-review modal's grouped summary.
export const groupChangesByType = (changes) => {
  const order = [];
  const map = {};
  for (const c of changes) {
    if (!map[c.type]) { map[c.type] = []; order.push(c.type); }
    map[c.type].push(c);
  }
  return order.map((type) => ({ type, items: map[type], meta: changeTypeMeta(type) }));
};
